import React from 'react'
import { Heading } from '../HeadingModule/Heading'
import '../../styles/ConciergeModule/GreetingHeading.scss'

interface GreetingHeadingProps {
  heading: string
  fallback: string
}

export const GreetingHeading = ({ heading, fallback }: GreetingHeadingProps) => {
  return <div className="greeting-heading">
        <Heading text={heading || fallback} as="h2" />
    </div>
}
